// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file lfd_overrides_service.proto (package domain, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file lfd_overrides_service.proto.
 */
export const file_lfd_overrides_service: GenFile = /*@__PURE__*/
  fileDesc("ChtsZmRfb3ZlcnJpZGVzX3NlcnZpY2UucHJvdG8SBmRvbWFpbiIzChpSZXBsYWNlTEZET3ZlcnJpZGVzUmVxdWVzdBIVCg1vdmVycmlkZV9qc29uGAEgAygJIh0KG1JlcGxhY2VMRkRPdmVycmlkZXNSZXNwb25zZSIxChlEZWxldGVMRkRPdmVycmlkZXNSZXF1ZXN0EhQKDG92ZXJyaWRlX2lkcxgBIAMoCSIcChpEZWxldGVMRkRPdmVycmlkZXNSZXNwb25zZSJfChdMaXN0TEZET3ZlcnJpZGVzUmVxdWVzdBJECiBsYXN0X2tub3duX292ZXJyaWRlc191cGRhdGVfdGltZRgBIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXAibQoYTGlzdExGRE92ZXJyaWRlc1Jlc3BvbnNlEjkKFW92ZXJyaWRlc191cGRhdGVfdGltZRgBIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXASFgoOb3ZlcnJpZGVzX2pzb24YAiADKAkyiwIKE0xGRE92ZXJyaWRlc1NlcnZpY2USVAoHUmVwbGFjZRIiLmRvbWFpbi5SZXBsYWNlTEZET3ZlcnJpZGVzUmVxdWVzdBojLmRvbWFpbi5SZXBsYWNlTEZET3ZlcnJpZGVzUmVzcG9uc2UiABJRCgZEZWxldGUSIS5kb21haW4uRGVsZXRlTEZET3ZlcnJpZGVzUmVxdWVzdBoiLmRvbWFpbi5EZWxldGVMRkRPdmVycmlkZXNSZXNwb25zZSIAEksKBExpc3QSHy5kb21haW4uTGlzdExGRE92ZXJyaWRlc1JlcXVlc3QaIC5kb21haW4uTGlzdExGRE92ZXJyaWRlc1Jlc3BvbnNlIgBCMFouZ2l0bGFiLmNvbS9jb3RlY2hkZS9tb25vcmVwby9iYWNrZW5kL2RvbWFpbi9wYmIGcHJvdG8z", [file_google_protobuf_timestamp]);

/**
 * @generated from message domain.ReplaceLFDOverridesRequest
 */
export type ReplaceLFDOverridesRequest = Message<"domain.ReplaceLFDOverridesRequest"> & {
  /**
   * id field from json will be used as identifier,
   * inserting or updating override as necessary
   *
   * @generated from field: repeated string override_json = 1;
   */
  overrideJson: string[];
};

/**
 * Describes the message domain.ReplaceLFDOverridesRequest.
 * Use `create(ReplaceLFDOverridesRequestSchema)` to create a new message.
 */
export const ReplaceLFDOverridesRequestSchema: GenMessage<ReplaceLFDOverridesRequest> = /*@__PURE__*/
  messageDesc(file_lfd_overrides_service, 0);

/**
 * @generated from message domain.ReplaceLFDOverridesResponse
 */
export type ReplaceLFDOverridesResponse = Message<"domain.ReplaceLFDOverridesResponse"> & {
};

/**
 * Describes the message domain.ReplaceLFDOverridesResponse.
 * Use `create(ReplaceLFDOverridesResponseSchema)` to create a new message.
 */
export const ReplaceLFDOverridesResponseSchema: GenMessage<ReplaceLFDOverridesResponse> = /*@__PURE__*/
  messageDesc(file_lfd_overrides_service, 1);

/**
 * @generated from message domain.DeleteLFDOverridesRequest
 */
export type DeleteLFDOverridesRequest = Message<"domain.DeleteLFDOverridesRequest"> & {
  /**
   * @generated from field: repeated string override_ids = 1;
   */
  overrideIds: string[];
};

/**
 * Describes the message domain.DeleteLFDOverridesRequest.
 * Use `create(DeleteLFDOverridesRequestSchema)` to create a new message.
 */
export const DeleteLFDOverridesRequestSchema: GenMessage<DeleteLFDOverridesRequest> = /*@__PURE__*/
  messageDesc(file_lfd_overrides_service, 2);

/**
 * @generated from message domain.DeleteLFDOverridesResponse
 */
export type DeleteLFDOverridesResponse = Message<"domain.DeleteLFDOverridesResponse"> & {
};

/**
 * Describes the message domain.DeleteLFDOverridesResponse.
 * Use `create(DeleteLFDOverridesResponseSchema)` to create a new message.
 */
export const DeleteLFDOverridesResponseSchema: GenMessage<DeleteLFDOverridesResponse> = /*@__PURE__*/
  messageDesc(file_lfd_overrides_service, 3);

/**
 * @generated from message domain.ListLFDOverridesRequest
 */
export type ListLFDOverridesRequest = Message<"domain.ListLFDOverridesRequest"> & {
  /**
   * @generated from field: google.protobuf.Timestamp last_known_overrides_update_time = 1;
   */
  lastKnownOverridesUpdateTime?: Timestamp | undefined;
};

/**
 * Describes the message domain.ListLFDOverridesRequest.
 * Use `create(ListLFDOverridesRequestSchema)` to create a new message.
 */
export const ListLFDOverridesRequestSchema: GenMessage<ListLFDOverridesRequest> = /*@__PURE__*/
  messageDesc(file_lfd_overrides_service, 4);

/**
 * @generated from message domain.ListLFDOverridesResponse
 */
export type ListLFDOverridesResponse = Message<"domain.ListLFDOverridesResponse"> & {
  /**
   * @generated from field: google.protobuf.Timestamp overrides_update_time = 1;
   */
  overridesUpdateTime?: Timestamp | undefined;

  /**
   * empty if last_known_overrides_update_time matches latest, otherwise contains all rules
   *
   * @generated from field: repeated string overrides_json = 2;
   */
  overridesJson: string[];
};

/**
 * Describes the message domain.ListLFDOverridesResponse.
 * Use `create(ListLFDOverridesResponseSchema)` to create a new message.
 */
export const ListLFDOverridesResponseSchema: GenMessage<ListLFDOverridesResponse> = /*@__PURE__*/
  messageDesc(file_lfd_overrides_service, 5);

/**
 * @generated from service domain.LFDOverridesService
 */
export const LFDOverridesService: GenService<{
  /**
   * errors:
   * - MissingCredentials (30100)
   * - InvalidCredentials (30420)
   * - BadRequest (10400): if json is malformed or missing required attributes
   * - Internal (10500)
   *
   * @generated from rpc domain.LFDOverridesService.Replace
   */
  replace: {
    methodKind: "unary";
    input: typeof ReplaceLFDOverridesRequestSchema;
    output: typeof ReplaceLFDOverridesResponseSchema;
  },
  /**
   * errors:
   * - MissingCredentials (30100)
   * - InvalidCredentials (30420)
   * - Internal (10500)
   *
   * @generated from rpc domain.LFDOverridesService.Delete
   */
  delete: {
    methodKind: "unary";
    input: typeof DeleteLFDOverridesRequestSchema;
    output: typeof DeleteLFDOverridesResponseSchema;
  },
  /**
   * errors:
   * - Internal (10500)
   *
   * @generated from rpc domain.LFDOverridesService.List
   */
  list: {
    methodKind: "unary";
    input: typeof ListLFDOverridesRequestSchema;
    output: typeof ListLFDOverridesResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_lfd_overrides_service, 0);

